import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";
import { Disclaimer } from "@/components/Disclaimer";
import { Target, Eye, ShieldCheck, Globe } from "lucide-react";

const values = [
  { icon: Eye, title: "Radical transparency", desc: "We publish losing signals alongside winners. No cherry-picking, no fake track records." },
  { icon: ShieldCheck, title: "Risk-first", desc: "Every tool centres on protecting capital: position sizing, stops and exposure limits." },
  { icon: Target, title: "Probabilistic, not promises", desc: "We never claim guaranteed profits. Signals are analytical estimates — nothing more." },
  { icon: Globe, title: "Built for the world", desc: "Multi-language, multi-currency architecture designed for international traders." },
];

export default function About() {
  return (
    <MarketingLayout>
      <Seo title="About" description="KREONIS is an international AI-powered market intelligence and trading-analysis platform." />
      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6">
        <span className="text-xs font-semibold uppercase tracking-widest text-accent">About</span>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight sm:text-5xl">A serious fintech platform — not a casino</h1>
        <p className="mt-4 text-lg text-muted-foreground">
          KREONIS combines market data, technical analysis and artificial intelligence to help traders understand
          market conditions, discover probabilistic setups and practise with powerful risk-management tools. We are a
          market-intelligence and education platform. We do not custody funds, execute real-money trades, or provide
          personalised regulated investment advice.
        </p>
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {values.map((v) => (
            <div key={v.title} className="rounded-2xl border border-border bg-card p-6">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10"><v.icon className="h-5 w-5 text-primary" /></div>
              <h3 className="mt-4 font-display text-lg font-semibold">{v.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{v.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-10"><Disclaimer /></div>
      </div>
    </MarketingLayout>
  );
}
